import { useToast as useChakraToast } from '@chakra-ui/react';

type ToastInfo = {
  title: string;
  description: string;
};

export const useToast = () => {
  const toast = useChakraToast();
  return {
    successToast: ({ title, description }: ToastInfo) => {
      toast({
        title,
        description,
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
    },
    errorToast: ({ title, description }: ToastInfo) => {
      toast({
        title,
        description,
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    },
  };
};
